import Head from 'next/head'
import { useRouter } from 'next/router'
import 'regenerator-runtime/runtime'
import Search from '../routes/Search/Search'

const Routes = ({ query }) => {
  return (
    <>
      <Head>
        <title>"{query}" - DecorMatters</title>
        <meta
          name="description"
          content={`Explore '${query}' designs on DecorMatters and find inspiration for your next home design project.`}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={`"${query}" - DecorMatters`} />
        <meta name="twitter:site" content="@decormattersapp" />
        <meta property="og:title" content={`"${query}" - DecorMatters`} />
        <meta
          property="og:description"
          content={`Explore '${query}' designs on DecorMatters and find inspiration for your next home design project.`}
        />
      </Head>
      <Search />
    </>
  )
}

export default Routes

export async function getServerSideProps({ query }) {
  try {
    return {
      props: {
        query: query.q
      }
    }
  } catch (error) {
    return {
      props: {}
    }
  }
}
